import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Table, Modal, notification, Tag } from "antd";
import LicensesService from "../services/licenses.service";
import {
  EditOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";

const { confirm } = Modal;

function TableLicenses(prop) {
  const { search, col } = prop;

  const columnsCompany = [
    {
      title: "Name",
      dataIndex: "name",
      key: "Name",
    },
    {
      title: "Origins",
      dataIndex: "alias",
      key: "alias",
    },
    {
      title: "Used",
      dataIndex: "used",
      key: "used",
      
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (text, record) => (
        <span>
            <Link to={"/licenses/" + text.id} style={{ marginRight: 16 }}>
                <EditOutlined /> View
            </Link>
        </span>
      ),
    },
  ];
  // state column
  const [columns, setColumns] = useState(columnsCompany);

  // state table
  const [company, setCompany] = useState([]);
  const [filterCompany, setFilterCompany] = useState([]);
  // const [pagination, setPagination] = useState({});
  const [loading, setLoading] = useState(false);

  ///search
  const filterSearch = () => {
    let temp = [...company];
    // let result = temp.filter(ele=> console.log( ele[`${col}`].toLowerCase()) )

    let result = temp.filter((ele) =>
      ele[`${col}`].toLowerCase().includes(search.toLowerCase())
    );

    setFilterCompany([...result]);
  };

  // fetch data
  const fetch = async (params = { page: 1, pageSize: 10 }) => {
    try {
      setLoading(true);
      const ret = await LicensesService.getLicenses();

      // check rem error
      if (ret.status !== 200) {
        throw { message: ret.data.message };
      }

      const data = ret.data;
      setLoading(false);
      setCompany(data);

      if (data.length > 0) {
        setColumns(columnsCompany);
      }
    } catch (error) {
      return;
    }
  };


  const conditionEffect = (e) => {
    if (search !== "") {
      return filterSearch();
    }

    return fetch();
  };

  useEffect(() => {
    conditionEffect();
  }, [search]);

  return (
    <>
      <Table
        columns={columns}
        rowKey={(record) => record.id}
        dataSource={search !== "" ? filterCompany : company}
        // pagination={pagination}
        loading={loading}
        // onChange={handleTableChange}
        scroll={false}
        className="table-row-pointer"
      />
    </>
  );
}

export default TableLicenses;